import { useEffect, useState } from 'react';
import ApiService from '../services/api.service';
import { isThaklisDisabled } from '../utils/roleUtils';

// One fetch per typing center per session; WorkOrderConfig resets it after a save.
const cache = new Map();

export const invalidateThaklisServicesCache = () => cache.clear();

export const isThaklisServicesEnabled = (tcId) => {
  if (!cache.has(tcId)) {
    cache.set(tcId, ApiService.getWorkOrderConfig(tcId)
      .then((resp) => {
        const c = resp?.data?.data || resp?.data || {};
        return c.thaklis_services_enabled === true;
      })
      .catch(() => false));
  }
  return cache.get(tcId);
};

/**
 * Whether Thaklis-facing UI (tickets, Thaklis payments, invoice-from-tickets) should be hidden for
 * this user: the platform Thaklis flag is off, or the Work Order Settings switch is off. Mirrors the
 * work-order service picker's own check. Hidden until the config arrives; platform users never hide.
 */
const useThaklisServicesOff = (currentUser) => {
  const tcId = currentUser?.typingCenterId || currentUser?.typing_center_id || null;
  const platformOff = isThaklisDisabled(currentUser);
  const [servicesEnabled, setServicesEnabled] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!tcId || platformOff) {
      setServicesEnabled(null);
      return undefined;
    }
    isThaklisServicesEnabled(tcId).then((enabled) => { if (!cancelled) setServicesEnabled(enabled); });
    return () => { cancelled = true; };
  }, [tcId, platformOff]);

  if (platformOff) return true;
  if (!tcId) return false;
  return servicesEnabled !== true;
};

export default useThaklisServicesOff;
